import { SelectSize } from './select.types'

export const SELECT_OFFSET = 4

// Note: Estimated option height in px for react-virtual
export const OPTION_HEIGHT_ESTIMATE: Record<SelectSize, number> = {
  medium: 40,
  small: 32,
}

// Note: Max nesting depth for recursive options
export const MAX_OPTION_DEPTH = 5

// Note: Indentation per depth level
export const OPTION_DEPTH_INDENT = '2.8rem'

// Note: mirrors `MAX_VISIBLE_CHIPS` in the client-profile badge overflow pattern
// (general-information.constants.ts) - badges mode caps at 10 and shows a
// `QuantityBadge` for the rest rather than rendering an 11th+ pill.
export const MAX_VISIBLE_BADGES = 10
